export const STANDALONE_ROUTES = [
  "/profile",
  "/settings",
  "/school",
  "/student-fee-ledgers/",
];
